define('restaurant',[
  // These are path alias that we configured in our bootstrap
  'jquery', 'underscore', 'backbone', 'model-collections/restaurant', 'classes/map', 'model-collections/menu', 'model-collections/review', 'views/email-form', 'common', 'bootstrap'],
  function($, _, Backbone, Restaurant, Map, Menu, Review, EmailFormView) {
    return function() {
      var map = null, menus = new Backbone.Collection, centre;

      var Router = Backbone.Router.extend({

        routes: {
          'restaurant/:slug-:id(/)': 'index',
          'restaurant/:slug-:id/map(/)': 'map',
          'restaurant/:restaurant/menu/:slug-:id(/)': 'menu'
        },

        initialize: function (restaurants) {
          this.restaurants = restaurants || {}; // for the map, has to come before history below
          this.menu_reload_handled = false;
          Backbone.history.start({pushState: true});
          var this_ = this;
          $('a.route').click(function (e) {
            e.preventDefault();
            this_.navigate($(this).attr('href'), {trigger: true});
          });
        },

        index: function() {

          // if we've come to the index from a menu, it's possible the restaurant info hasn't loaded. if so, reload page
          if (!$('#re-description').length) {
            window.location.reload();
            return;
          }

          tab_focus('#re-info-tab');
          $('.re-page').hide();
          $('#re-main').show();
          $(document).trigger('resize-done');
        },

        map: function() {

          // if we've come to the index from a menu, it's possible the restaurant map hasn't loaded. if so, reload page
          if (!$('#re-map').length) {
            window.location.reload();
            return;
          }

          tab_focus('#re-map-tab');
          $('.re-page').hide();
          $('#re-map-wrapper').show();
          if (!map) {
            map = new Map('re-map', this.restaurants, map_coords.center);
          }
          $(document).trigger('resize-done');
        },

        menu: function(restaurant, slug, id) {
          var elem = '#re-menu-tab-' + id,
              skip = $(elem).parent().hasClass('active') && !this.menu_reload_handled;

          // This is to prevent the loading of the menu via JSON if you load the menu page directly
          this.menu_reload_handled = true;
          if (skip) {
            return;
          }

          tab_focus(elem);
          if (!menus.findWhere({id: id})) {
            $('#re-page-loading').show();
            var menu = new Menu.Model({id: id});
            menu.fetch({
              success: function (model, response, options) {
                var menu_view = new Menu.View({model: model, el: $('#re-pages')});
                $('.re-page, #re-page-loading').hide();
                $('#re-menu-' + id).show();
                $(document).trigger('resize-done');
              }
            });
            menus.add(menu);
          }
          else {
            $('.re-page').hide();
            $('#re-menu-' + id).show();
            $(document).trigger('resize-done');
          }
        }

      });

      $(document).ready(function() {

        $('i.glyphicon').tooltip({placement: 'left'});

        new EmailFormView({
          el: '#re-email',
          anchor: '#re-email-a',
          url: '/restaurant/email'
        });

        var map;
        var current_restaurant_id = typeof window.current_restaurant_id != 'undefined' ? window.current_restaurant_id : null;

        var restaurants = new Restaurant.Collection(); // for the map

        new Router(restaurants);

        new Review.View({
          el: '#re-reviews-view',
          restaurant_id: current_restaurant_id
        });

        if ($.isMobileSite()) {
          $('#re-map').height(($(window).height() - 100) + 'px');
          window.addEventListener('resize', function() {
            $('#re-map').height(($(window).height() - 100) + 'px');
          });
        }
        else {
          var min_map_height = 500, min_body_height = $(window).height() - 260;
          var map_height = min_body_height - 235;
          if (map_height < min_map_height) {
            map_height = min_map_height;
          }
          $('#re-map').height((map_height) + 'px');

          $('.re-instagram-thumb').click(function() {
            var index = $('.re-instagram-thumb').index(this);
            $('#re-instagram-carousel').carousel(index);
          });
        }

        if ($('#re-gallery-modal').length) {
          var success_function = function(element){
            setTimeout(function(){
              var parent = element.parentNode;
              parent.className = parent.className.replace(/\bloading\b/,'');
            }, 200);
          };

          new Blazy({
            container: '#re-instagram-thumbs',
            success: success_function
          });

          $('#re-gallery-modal').on('show.bs.modal', function() {
            if (typeof this.blazyLoaded == 'undefined') {
              var bLazy = new Blazy({
                breakpoints: [{
                  width: 420, // Max-width
                  src: 'data-src-small'
                }],
                container: '#re-instagram-carousel',
                loadInvisible: true,
                success: success_function
              });
              this.blazyLoaded = true;
            }
          });
        }
      });

      function tab_focus(elem) {
        if ($.isMobileSite()) {
          $('#re-nav-mob .active').removeClass('active').blur();
          $(elem).parent().addClass('active');
        }
        else {
          $(elem).parent()
            .addClass('active')
            .siblings('.active:first')
              .removeClass('active')
              .children(':first-child')
                .blur();
        }
      }

    }
}
);
